import { render, staticRenderFns } from "./IssuanceModal.vue?vue&type=template&id=6927c3fe&"
import script from "./IssuanceModal.vue?vue&type=script&lang=js&"
export * from "./IssuanceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports